import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { hasAceptadoTerminos, registrarAceptacion } from "../../utils/terminosStorage";
import ModalTerminos from "./ModalTerminos";

/**
 * Envuelve cualquier vista protegida y muestra el modal de Políticas de
 * Privacidad si el usuario autenticado aún no ha aceptado la versión vigente.
 * El modal es imposible de cerrar hasta que el usuario acepte.
 *
 * Uso:
 *   <TerminosGuard>
 *     <MiDashboard />
 *   </TerminosGuard>
 */
const TerminosGuard = ({ children }) => {
  // Modal deshabilitado temporalmente — reactivar eliminando este return
  return <>{children}</>;

  // eslint-disable-next-line no-unreachable
  const { usuario } = useSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (usuario && !hasAceptadoTerminos(usuario)) {
      setShowModal(true);
    }
  }, [usuario]);

  const handleAceptar = () => {
    registrarAceptacion(usuario);
    setShowModal(false);
  };

  return (
    <>
      {children}
      {showModal && (
        <ModalTerminos open={showModal} onAceptar={handleAceptar} />
      )}
    </>
  );
};

TerminosGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TerminosGuard;
